/*
  ============================================================
  ظهور العناصر بالزوم عند السكرول — [data-reveal-zoom]
  ------------------------------------------------------------
  كان جوّه footer.js. اتنقل لملف لوحده، والسبب مهم:

  footer.js بيتحمّل من **سكشن الفوتر**. يعني أول ما التاجر يخفي
  الفوتر من المخصّص، الملف مبيترندرش خالص — وكل حركات الزوم في
  الموقع بتموت من غير أي رسالة خطأ. ده حصل فعلاً: الفوتر اتقفل،
  والكاتيجوريز و Shop the look و FAQ و Image marquee فضلوا ساكتين.

  و preload اللي كان في theme.liquid مكانش بيساعد في الحالة دي —
  بينزّل الملف بس من غير وسم <script> مفيش حاجة بتشغّله.

  دلوقتي بيتحمّل من theme.liquid على طول: مستقل عن أي سكشن،
  وبيشتغل بدري (مش عند ٩٤٪ من الصفحة زي ما كان) فالعناصر بتتراقب
  قبل ما المستخدم يعدّيها.
  ============================================================
*/
/* ============================================================
   ظهور صور إنستجرام عند السكرول.

   وحدة مستقلة عن نظام .scroll-trigger بتاع الثيم عن قصد: نمط
   الأنيميشن "Zoom" بيلغي كشف السكشنات بالكامل، فلو اتبنت عليه
   مكانتش هتشتغل. الحركة نفسها بتقرا متغيرات كارت المنتج فبتفضل
   متسقة مع باقي الموقع.
   ============================================================ */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.15 }
  );

  function scan(root) {
    var fresh = [];

    /* [data-reveal-zoom] خطّاف عام لأي سكشن عايز نفس الحركة —
       بيحط .reveal-zoom بس والسكشن بيعرّف شكله بنفسه. */
    (root || document)
      .querySelectorAll('[data-ig-reveal], [data-reveal-zoom]')
      .forEach(function (el) {
        if (el.dataset.igRevealBound) return;
        el.dataset.igRevealBound = '1';

        var revealClass = el.hasAttribute('data-ig-reveal')
          ? 'footer-instagram--reveal'
          : 'reveal-zoom';

        /* ============================================================
           العنصر اللي المستخدم عدّاه خلاص بيتعلّم مكشوف على طول.

           الملف ده بيتحمّل من الفوتر — يعني عند ٩٤٪ من الصفحة.
           على أول زيارة بكاش فاضي، الـ HTML بيوصل بالتدريج
           والمستخدم بيبدأ يعمل سكرول قبل ما السكربت ده ينزّل
           ويشتغل أصلاً.

           النتيجة قبل الإصلاح: الدالة دي بتلاقي سكشن المستخدم
           عدّاه، بتحط عليه .reveal-zoom (وفيها opacity: 0)،
           وبتراقبه. وهو فوق الشاشة فعمره ما هيتقاطع تاني —
           فبيفضل **مختفي تمامًا** لحد ما المستخدم يرجع لفوق.

           ده مش مجرد حركة ضايعة، ده محتوى بيختفي. القياس تحت
           بيمسك الحالة دي ويكشف العنصر فورًا من غير حركة —
           الحركة اتفاتت خلاص، بس المحتوى بيفضل ظاهر.

           getBoundingClientRect هنا مقبولة: بتتنفّذ مرة واحدة
           لكل عنصر وقت التجهيز، مش في لوب سكرول.
           ============================================================ */
        if (el.getBoundingClientRect().bottom < 0) {
          el.classList.add(revealClass, 'is-revealed');
          return;
        }

        el.classList.add(revealClass);
        fresh.push(el);
      });

    if (!fresh.length) return;

    /* ============================================================
       لازم المتصفح يرسم الحالة المخفية قبل ما نراقب.

       الكلاس اللي فوق بيحط opacity: 0. لو راقبنا في نفس اللحظة،
       المراقب بيرجّع نتيجته بعد شوية وبيحط is-revealed — ولو
       المتصفح ماكانش رسم حالة الـ 0 لسه، الترانزيشن بتتلغي
       والعنصر بيظهر فجأة من غير أي حركة.

       ده بيحصل تحديدًا على أول تحميل بارد: الملف ده بيترندر مع
       الفوتر (٩٤٪ من الصفحة) فبيشتغل متأخر، وبيلاقي سكشنات آخر
       الصفحة **في الشاشة فعلاً**. فالكلاسين بيتحطوا ورا بعض
       والحركة بتضيع. بعد الريفريش الملف بيشتغل بدري والعناصر
       تحت الطية، فالحالة بتترسم قبلها بوقت طويل والحركة بتشتغل.

       الـ rAF المزدوجة بتضمن إطار كامل بينهم — نفس اللي
       card-product-modern.js بيعمله في armCards بالظبط، ولنفس
       السبب.
       ============================================================ */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fresh.forEach(function (el) {
          observer.observe(el);
        });
      });
    });
  }

  /* ============================================================
       ونستنى ستارة اللودر زي animations.js.

       طول ما html.sa-loading موجود الصفحة مغطّاة. أي عنصر بيتكشف
       دلوقتي حركته بتحصل ورا الغطاء والمستخدم مبيشوفهاش — نفس
       المشكلة الموثّقة في animations.js، بس الملف ده مكانش
       بياخد بالها.

       لو الكلاس مش موجود (اللودر متقفل) بيشتغل فورًا. والمؤقت
       شبكة أمان لو الحدث ماجاش لأي سبب.
       ============================================================ */
  function whenReady(fn) {
    if (!document.documentElement.classList.contains('sa-loading')) {
      fn();
      return;
    }
    var done = false;
    var run = function () {
      if (done) return;
      done = true;
      fn();
    };
    document.addEventListener('theme:loader:done', run, { once: true });
    setTimeout(run, 5000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { whenReady(scan); });
  } else {
    whenReady(scan);
  }

  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
})();
